import './ContactForm.css'
import React, { useState } from 'react';
import { sendContactEmail } from '../../api/contactApi';
import { toast } from 'react-toastify';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await sendContactEmail(formData);
      toast.success('Votre message a été envoyé avec succès !');
      setFormData({
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      toast.error(error.message || 'Une erreur est survenue lors de l\'envoi du message');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="homepage_form_container" onSubmit={handleSubmit}>
      <div className="form-group-contactform">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Votre adresse email"
        />
      </div>

      <div className="form-group-contactform">
        <label htmlFor="subject">Objet du message</label>
        <input
          type="text"
          id="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          placeholder="L'objet de votre message"
        />
      </div>

      <div className="form-group-contactform">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          value={formData.message}
          onChange={handleChange}
          required
          placeholder="Votre message..."
        ></textarea>
      </div>

      <button 
        type="submit" 
        className="submit-btn"
        disabled={isLoading}
      >
        {isLoading ? 'Envoi en cours...' : 'Envoyer'}
      </button>
    </form>
  );
};

export default ContactForm;
